// import { useInfiniteScroll } from '@vueuse/core'
import { cyolistStore }  from '@/stores/cyolist/cyolist';
import { useInfiniteScroll } from '@vueuse/core'


export function callRequestServer( clearListing ) {

    const route = useRoute();
    
    const moduleType = route.meta?.moduleType;
    const moduleSubType = route.meta?.moduleSubType;

    let storeKey = `list-${moduleType}-${moduleSubType}-store`
    
    if(!moduleType || !moduleSubType) {
        storeKey = `list-${route.name}-store`
    }

    const store = cyolistStore(storeKey);

    if (clearListing) {
        store.commitMutation('setSettingShowSkeleton', { flag: true });
        store.commitMutation('setSettingListingResults', {
            clearListing: true,
            response: { data: [], total: 0, next_page_url: null },
        });
        // reset();
        store.requestServer({ clearListing : true});
        return;
    }
}

export function useInfiniteScrollComposable( infiniteScrollContainer, getSettingListingNextPageUrl ) {
    const route = useRoute();
    // const router = useRouter();
    // const store = cyolistStore(route.meta.storeName);

    // const { reset } = useInfiniteScroll(
    //     infiniteScrollContainer,
    //     onLoadMore,
    //     {
    //         distance: 500,
    //         immediate: false,
    //         canLoadMore: () => Boolean(getSettingListingNextPageUrl.value),
    //     }
    // );
    if(!import.meta.client){

        return
    }

    watch(
        () => route.query,
        (newVal, oldVal) => {
            const oldQuery = { ...oldVal };
            const newQuery = { ...newVal };

            delete newQuery.page;
            delete oldQuery.page;

            delete newQuery.Listview;
            delete oldQuery.Listview;

            let clearListing = JSON.stringify(newQuery) !== JSON.stringify(oldQuery);

            const reset = newVal.page && newVal.page < 2 ? true : false
            callRequestServer(clearListing)
        },
        { deep: true }
    );

    return { infiniteScrollContainer };
}

export async function onLoadMore() {
    const route = useRoute();
    const moduleType = route.meta?.moduleType;
    const moduleSubType = route.meta?.moduleSubType;

    let storeKey = `list-${moduleType}-${moduleSubType}-store`
    
    if(!moduleType || !moduleSubType) {
        storeKey = `list-${route?.name}-store`
    }

    const store = cyolistStore(storeKey);
    store.setLoader(true)   
    await store.requestServer({ clearListing : false});
    store.setLoader(false)


    return
}